import { SuccessorBorrowerSummary } from './SuccessorBorrowerSummary';

export default SuccessorBorrowerSummary;
